/* eslint-disable jsx-a11y/anchor-is-valid */

'use client';

import React from 'react';
import Author from 'ui/src/components/Author';
import Image from '../Image';

type CardAuthorProps = {
  imageUrl: string;
  name: string;
  withAuthorAvatar?: boolean;
};

function CardAuthor({ imageUrl, name, withAuthorAvatar = true }: CardAuthorProps) {
  return (
    <span>
      <Author align="center" classes="gap-1">
        {withAuthorAvatar && (
          <Author.Image>
            <Image
              src={imageUrl}
              unoptimized
              width={58}
              height={58}
              alt=""
              className="rounded-full object-cover"
            />
          </Author.Image>
        )}
        <Author.Name>{name}</Author.Name>
      </Author>
    </span>
  );
}

export default CardAuthor;
